module.exports = new __parcel__URL__("troubleshooting.7fc0357d.svg").toString();